import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import CartMain from "./CartMain";
import Footer from "../../components/Footer";

const Cart = () => {
  return (
    <>
      <HeaderFour />

      <CartMain />

      <Footer />
    </>
  );
};

export default Cart;
